import { Model } from "../../lib";
import { observable } from "mobx";

export enum AppIntegrationState {
  GRANTED = "granted",
  QUEUED_REVOKE = "queued_revoke",
  REVOKED = "revoked",
}

export enum AppIntegrationProvider {
  PLAYFAB = "playfab",
}

export interface IAppIntegration {
  app_id?: string;
  provider?: AppIntegrationProvider;
  state?: AppIntegrationState;
}

export class AppIntegration extends Model<IAppIntegration> implements IAppIntegration {
  @observable app_id?: string;
  @observable provider?: AppIntegrationProvider;
  @observable state?: AppIntegrationState;

  public static getAppIntegrationResourceId(appId: string | undefined, provider: AppIntegrationProvider | undefined) {
    return `${appId?.toLowerCase()}|${provider?.toLowerCase()}`;
  }
}
